import { Pipe, PipeTransform } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'userId',
})
export class UserByIdPipe implements PipeTransform {
  user$: Observable<any>;

  constructor(private apollo: Apollo) {}

  transform(value: any, args?: any): any {
    // if (value) {
    //   this.user$ = this.apollo
    //     .query({
    //       query: gql`
    //         query userInfoById($userId: Long!) {
    //           userInfoById(id: $userId) {
    //             code
    //             data {
    //               id
    //               firstName
    //               lastName
    //             }
    //           }
    //         }
    //       `,
    //       variables: {
    //         userId: +value,
    //       },
    //       fetchPolicy: 'network-only',
    //     })
    //     .pipe(
    //       map(({ data }: any) => {
    //         if (data.userInfoById.code === 9000) {
    //           const user: User = data.userInfoById.data;
    //           return user?.firstName + ' ' + user?.lastName;
    //         } else {
    //           return '';
    //         }
    //       })
    //     );
    //
    //   return this.user$;
    // }
  }
}
